import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../../common/success-dialog/success-dialog.component';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {
  createAccountForm: FormGroup;
  errorMessage: string = '';
  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, private dialog: MatDialog ) { }

  ngOnInit(): void {
    this.createAccountForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      dateOfBirth: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: this.mustMatch('password', 'confirmPassword')
    });
  }





  // Custom validator to check if password and confirm password match
  mustMatch(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors['mustMatch']) {
        // return if another validator has already found an error on the confirmPasswordControl
        return;
      }

      // set error on confirmPasswordControl if validation fails
      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ mustMatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    };
  }

onSubmit() {
  if (this.createAccountForm.invalid) {
    this.errorMessage = 'Please fill all required fields correctly.';
    return;
  }

    // Extract form values
    const formValues = this.createAccountForm.value;
    const user = {
      email: formValues.email,
      password: formValues.password,
      firstname: formValues.firstName,
      lastname: formValues.lastName,
      dob: formValues.dateOfBirth,
      // Include additional fields as required by your API
    };

    // Call AuthService to register the user
    this.authService.register(user).subscribe({
      next: (res) => {
        console.log('Registration successful', res);
        this.dialog.open(SuccessDialogComponent, {
          width: '400px',
          data: { message: 'Registration successful! Please log in and verify your email.' }
        }).afterClosed().subscribe(() => {
          // Navigate to the login page after closing the dialog
          this.router.navigate(['/login']);
        });
      },
      error: (err) => {
        console.error('Registration failed', err);
        this.errorMessage = err.error.message || 'Registration failed. Please try again later.';
      }
    });
  }
}
